import { useFormContext } from 'react-hook-form';
import { PurposeOfUseCostCenterAndEmployeeNumber } from './components/PurposeOfUseCostCenterAndEmployeeNumber.js';
import { PurposeOfUseSelector } from './components/PurposeOfUseSelector.js';
import type { Contact, ContactHeader } from '../../generated/api/models.js';

import './PurposeOfUse.scss';

export interface PurposeOfUseProps {
  companyName?: string;
  fieldPrefix?: string;
  contacts?: Contact[] | ContactHeader[];
  isEmailMandatory?: boolean;
  isPhoneNumberMandatory?: boolean;
  isCostCenterMandatory?: boolean;
  onChangeContact?: (
    selectedContactId: string,
    resetField: (name: string, options?: Record<string, boolean>) => void
  ) => void;
  onCreateUser?: () => void;
  isCreatingUser?: boolean;
  showHeaderAndDescription?: boolean;
  useCreateContactModal?: boolean;
  selectorLabel?: string;
  showCostCenterAndEmployeeNumberTitle?: boolean;
}

export const PurposeOfUse = ({
  companyName,
  contacts,
  fieldPrefix = '',
  isCostCenterMandatory,
  isEmailMandatory,
  isPhoneNumberMandatory,
  onChangeContact,
  onCreateUser,
  isCreatingUser,
  showHeaderAndDescription = true,
  useCreateContactModal = false,
  showCostCenterAndEmployeeNumberTitle = true,
  selectorLabel,
}: PurposeOfUseProps) => {
  const { resetField } = useFormContext();

  const onContactChange = (selectedContactId: string) => {
    if (onChangeContact) {
      onChangeContact(selectedContactId, resetField);
    }
  };

  return (
    <>
      <PurposeOfUseSelector
        companyName={companyName}
        contacts={contacts}
        fieldPrefix={fieldPrefix}
        isEmailMandatory={isEmailMandatory}
        isPhoneNumberMandatory={isPhoneNumberMandatory}
        onChangeContact={onContactChange}
        onCreateUser={onCreateUser}
        isCreatingUser={isCreatingUser}
        showHeaderAndDescription={showHeaderAndDescription}
        useCreateContactModal={useCreateContactModal}
        label={selectorLabel}
      />
      <PurposeOfUseCostCenterAndEmployeeNumber
        fieldPrefix={fieldPrefix}
        isCostCenterMandatory={isCostCenterMandatory}
        showTitle={showCostCenterAndEmployeeNumberTitle}
      />
    </>
  );
};
